export const HOME_TITLE = 'מזרח ללא גבולות';
export const HOME_SUBTITLE =
  'גלו יעדים מדהימים וחוויות טיול ייחודיות במזרח הרחוק';
export const RANDOM_ARTICLE_TITLE = 'דברים שכדאי לדעת';
export const ATTRACTIONS_RECOMMENDATIONS_TITLE = 'טיולים מומלצים';
